import * as React from 'react';
import { Navigate } from 'react-router-dom';

import PlantDetailQueryContainer from '../../../components/plant/queries/PlantDetailQuery';
import IPlantModel from '../../../models/IPlantModel';
import Routing from '../../../Routing';
import withMainNavigation from '../../withMainNavigation';
import { withRouter } from '../../../utils/withRouter';
import PlantOnboardingQuery from './PlantOnboardingQuery';

class PlantOnboardingContainer extends React.Component<any, any> {
    public renderOnboarding = (plantData: IPlantModel, refetch?: () => void) => {
        return plantData ? (
            <PlantOnboardingQuery refetch={refetch} plant={plantData} />
        ) : (
            <Navigate to={Routing.PLANTS.route} />
        );
    };

    public render() {
        const { plantId } = this.props.router.params;

        return (
            <>
                {plantId && (
                    <PlantDetailQueryContainer
                        id={plantId}
                        renderFetchedPlantData={this.renderOnboarding}
                    />
                )}
            </>
        );
    }
}

export default withRouter(withMainNavigation(PlantOnboardingContainer));
